import type {ISearchComboboxIconProps} from "../types/ISearchComboboxIconProps";
import {SearchComboboxSvgIcon} from "./SearchComboboxSvgIcon";

/** Info glyph, 16px. */
export const SearchComboboxInfoIcon = (props: ISearchComboboxIconProps) => (
    <SearchComboboxSvgIcon frameSize={16} {...props}>
        <path
            d="M8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667Z"
            stroke="currentColor"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M8 10.6667V8" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 5.33333H8.00667" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </SearchComboboxSvgIcon>
);
import type {ISearchComboboxIconProps} from "../types/ISearchComboboxIconProps";
import {SearchComboboxSvgIcon} from "./SearchComboboxSvgIcon";

/** Info glyph, 16px. */
export const SearchComboboxInfoIcon = (props: ISearchComboboxIconProps) => (
    <SearchComboboxSvgIcon frameSize={16} {...props}>
        <path
            d="M8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667Z"
            stroke="currentColor"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M8 10.6667V8" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 5.33333H8.00667" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </SearchComboboxSvgIcon>
);
